<script lang="ts">
	import BaseConditionNode from '../BaseConditionNode.svelte';
	import type { NodeData } from '../../types/flow-types';
	import { getFlowCardDefinition } from '../../core/card-engine/registry';

	export let id: string;
	export let data: NodeData;
	export let selected = false;
	export let validated = true;
	export let errors: string[] = [];

	const definition = getFlowCardDefinition('presenceCondition');
	$: summary = definition?.summary(data) || 'Configure Presence';
</script>

<BaseConditionNode
	{id}
	type="presenceCondition"
	{data}
	{selected}
	{validated}
	{errors}
	cardTitle={data.device?.name || 'Presence'}
	nodeTypeLabel="Presence condition"
	{...$$restProps}
>
	<div class="presence-summary">{summary}</div>
</BaseConditionNode>

<style>
	.presence-summary {
		font-size: 0.8125rem;
		line-height: 1.4;
	}
</style>
